// extracted by mini-css-extract-plugin
export default {"KeybindingHint":"CreateIssueFooter-module__KeybindingHint--hiruh","KeybindingHintText":"CreateIssueFooter-module__KeybindingHintText--M0X3m"};